<template>
    <div>
        <div v-if="isModalShow" class="dim-overlay" @click="closeModal"></div>
        <div id="addressSearch" class="modal" :style="{ display: isModalShow ? 'block' : 'none' }" tabindex="-1"
             role="dialog" aria-labelledby="addressModalCenterTitle" :aria-hidden="!isModalShow"
             @click.self="closeModal">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content" style="max-height: 90vh;">
                    <div class="modal-header" style="border: none;">
                        <button type="button" class="close" @click="closeModal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form class="-js-adress-form" @submit.prevent="searchSubmit">
                            <input type="hidden" name="CallInfo" :value="callInfo"/>
                            <input type="hidden" name="CallIdx" :value="callIdx"/>

                            <div class="row">
                                <div class="col">
                                    <div class="input-bottom">
                                        <input
                                            style="width: 75%; display: inline-block; border: none;"
                                            class="-js-address-input form-control input-bottom"
                                            type="text"
                                            v-model="address"
                                            autocomplete="off"
                                            placeholder="예) 예식장 또는 장례식장명을 입력해주세요"
                                            @input="toggleClearButton"
                                        />
                                        <button
                                            v-if="showClearButton"
                                            @click="clearInput"
                                            type="button"
                                            class="-js-address-search-clear-button searchClear-wrap">
                                            <span class="searchClear"></span>
                                        </button>
                                        <button title="검색" class="search-icon" type="submit"></button>
                                    </div>
                                </div>
                            </div>
                            <div class="address-form">
                                <!-- 디폴트 -->
                                <div v-if="showTip && !loading && !results.length" style="padding: .5rem;"
                                     class="-js-address-tip-div">
                                    <h4><b>Tip</b></h4>
                                    <p>아래와 같은 조합으로 검색을 하시면 더욱 정확한 결과가 검색됩니다.</p>
                                    <ul style="padding-left: 0;">
                                        <li>
                                            <p style="margin: 0;">지역명(동/리) + 예식장/장례식장명</p>
                                            <p style="color: #959595;">예) 여의도 예식장, 여의도 장례식장</p>
                                        </li>
                                        <li>
                                            <p style="margin: 0;">도로명 + 건물번호</p>
                                            <p style="color: #959595;">예) 판교역로 235, 제주 첨단로 242</p>
                                        </li>
                                        <li>
                                            <p style="margin: 0;">지역명(동/리) + 번지</p>
                                            <p style="color: #959595;">예) 삼평동 681, 제주 영평동 2181</p>
                                        </li>
                                        <li>
                                            <p style="margin: 0;">지역명(동/리) + 건물명(아파트명)</p>
                                            <p style="color: #959595;">예) 분당 주공, 연수동 주공3차</p>
                                        </li>
                                        <li>
                                            <p style="margin: 0;">사서함명 + 번호</p>
                                            <p style="color: #959595;">예) 분당우체국사서함 1~100</p>
                                        </li>
                                    </ul>
                                </div>
                                <!-- 검색했을시 -->
                                <div v-if="!loading && results.length" style="display: block;"
                                     class="-js-address-list-div address-form-list">
                                    <ul style="padding-left: 0;" class="-js-address-list-ul">
                                        <li v-for="(result, index) in results" :key="index">
                                            <p class="cursor-pointer" style="margin: 0 0 5px 0;"
                                               @click="selectAddress(result, 'jibun')">
                                                {{ result.jibunAddress }} {{ result.addressDetail || "" }}
                                            </p>
                                            <p v-if="result.roadAddress" style="color: #959595;" class="cursor-pointer"
                                               @click="selectAddress(result, 'road')">
                                                [도로명] {{ result.roadAddress }} {{ result.addressDetail || "" }}
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                                <!-- 검색 리스트 로딩 -->
                                <div v-if="loading" class="-js-address-loading-div">
                                    <div class="loadingBox">
                                        <div class="circle"></div>
                                    </div>
                                </div>
                                <!-- 검색결과 없을시 -->
                                <div v-if="!loading && !results.length && showEmptyMessage"
                                     class="-js-address-empty-div address-form-list-none">
                                    <div style="text-align: center;">
                                        <i class="n-icon02"></i>
                                        <span>검색결과가 없습니다.</span><span style="color: #959595;"> 다시 한번 확인해 주세요.</span>
                                    </div>
                                </div>
                                <!-- 상세주소입력 -->
                                <div v-if="showDetailInput" class="-js-address-detail-div" style="height: 65vh;">
                                    <div class="form-group" style="margin-bottom: 2rem;">
                                        <div class="row">
                                            <div class="col">
                                                <input
                                                    class="form-control"
                                                    type="text"
                                                    v-model="tempAddress"
                                                    autocomplete="off"
                                                    readonly
                                                />
                                            </div>
                                        </div>
                                        <div class="row" style="margin-top: 0.5rem;">
                                            <div class="col">
                                                <input
                                                    class="-js-temp-address-detail form-control"
                                                    type="text"
                                                    v-model="tempAddressDetail"
                                                    autocomplete="off"
                                                    placeholder="상세주소"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div style="text-align: center;">
                                        <i class="n-icon02"></i>
                                        <span>상세주소를 입력해 주세요.</span>
                                    </div>
                                    <input
                                        v-if="false"
                                        class="-js-delivery-charge-input form-control"
                                        type="text"
                                        v-model="deliveryCharge"
                                        readonly
                                    />

                                    <div v-if="this.hasReplacement" v-html="this.replacementProductHtml">
                                    </div>

                                    <button @click="confirmAddress" class="-js-address-detail-button bt-btn" :class="hasReplacement && !replacementProductId ? 'disabled' : ''"
                                            type="button">
                                        <span>확인</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        callInfo: {
            type: String,
            default: "",
        },
        callIdx: {
            type: String,
            default: "",
        },
        carts: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            address: "", // 주소 입력창
            results: [], // 주소 검색결과
            loading: false,
            showTip: true,
            showEmptyMessage: false, // 검색 결과 없을시 메시지
            showClearButton: false, // x 버튼 표시
            showDetailInput: false, // 상세주소 입력 메시지
            tempAddress: "", // 상세 주소
            tempAddressDetail: "", // 상세 주소 입력
            tempAddressZipcode: "", // 우편번호
            deliveryCharge: 0, // 배송비
            isModalShow: false,
            hasReplacement: false,
            replacementProductHtml: '',
            replacementTargetCartIds : [],
            replacementId: null,
            replacementProductId: null,
        };
    },
    methods: {
        openModal() {
            this.isModalShow = true;
        },
        closeModal() {
            this.isModalShow = false;
            this.resetState();
        },
        toggleClearButton() {
            this.showClearButton = !!this.address;
        },
        clearInput() {
            this.address = "";
            this.results = [];
            this.showTip = true;
            this.showEmptyMessage = false;
            this.showClearButton = false;
            this.showDetailInput = false;
        },
        searchSubmit() {
            this.results = [];
            this.loading = true;
            this.showTip = false;
            this.showDetailInput = false;
            this.showEmptyMessage = false;
            axios
                .post("/areas/search", {address: this.address, delivery_charge: "on", cart_ids: this.cartIds()})
                .then((response) => {
                    if (response.data.code === 0) {
                        this.results = response.data.data.addressArray || [];
                        this.showEmptyMessage = this.results.length === 0;
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        selectAddress(item, addressType = 'jibun') {
            if (addressType === 'road') {
                this.tempAddress = item.roadAddress || "";
            } else {
                this.tempAddress = item.jibunAddress || "";
            }

            this.tempAddressDetail = item.addressDetail || "";
            this.tempAddressZipcode = item.zipcode || "";
            this.deliveryCharge = item.deliveryCharge || 0;
            this.showDetailInput = true;
            this.results = [];
            this.showEmptyMessage = false;
            this.showTip = false;

            if (item.replacement !== undefined) {
                this.hasReplacement = true;
                this.replacementId = item.replacement.id;
                this.replacementTargetCartIds = item.replacement.carts;

                this.bindReplacementProductList(this.replacementId);
            } else {
                this.hasReplacement = false;
                this.replacementTargetCartIds = [];

                this.bindReplacementProductList(null);
            }
        },
        confirmAddress() {
            if (this.hasReplacement && !this.replacementProductId) {
                alert('대체 상품을 선택해주세요.');
                return;
            }

            const payload = {
                address: this.tempAddress || "",
                address_detail: this.tempAddressDetail || "",
                deliveryCharge: this.deliveryCharge || 0,
                zipcode: this.tempAddressZipcode || "",
                replacement: {
                    id : this.replacementId,
                    cartIds: this.replacementTargetCartIds,
                    replacementProductId: this.replacementProductId,
                }
            };
            this.$emit('address-selected', payload);
            // 네이티브 앱 호출 (Flutter)
            try {
                if (window.flutter_inappwebview) {
                    window.flutter_inappwebview.callHandler(
                        'handlerAddressData',
                        payload.address,
                        payload.address_detail,
                        payload.zipcode,
                        payload.deliveryCharge
                    ).then(result => {
                        // console.log('Flutter Result:', result);
                    });
                }
            } catch (e) {
                // console.error('Flutter 호출 실패:', e);
            }

            // 네이티브 앱 호출 (Android)
            try {
                if (window.MyAndroid) {
                    window.MyAndroid.handlerAddressData(
                        payload.address,
                        payload.address_detail,
                        payload.zipcode,
                        payload.deliveryCharge
                    );
                }
            } catch (e) {
                // console.error('Android 호출 실패:', e);
            }

            // 모달 닫기
            this.closeModal();
        },
        productCodes() {
            let codes = [];
            this.carts.forEach(function (item) {
                codes.push(item.product.code);
            })

            return codes;
        },
        bindCategories() {
            let categories = [];
            this.carts.forEach(function (item) {
                item.product.product_categories.forEach(function (category) {
                    categories.push(category);
                });
            });

            this.categories = categories;
        },
        cartIds() {
            let cartIds = [];
            this.carts.forEach(function (item) {
                cartIds.push(item.id);
            });

            return cartIds;
        },
        bindReplacementProductList(replacementId) {
            let self = this;
            if (replacementId) {
                axios
                    .get(`/products/replacement/${replacementId}`,)
                    .then((response) => {
                        self.replacementProductHtml = response.data;
                    })
                    .catch((error) => {
                        console.error("Error:", error);
                    });
            } else {
                self.replacementProductHtml = '';
            }
        },
        resetState() {
            this.address = "";
            this.results = [];
            this.showTip = true;
            this.showClearButton = false;
            this.showEmptyMessage = false;
            this.showDetailInput = false;
            this.hasReplacement = false;
            this.tempAddress = "";
            this.tempAddressDetail = "";
            this.tempAddressZipcode = "";
            this.deliveryCharge = "on";
            this.replacementProductHtml = "";
            this.replacementProductId = null;
            this.replacementId = null;
            this.replacementTargetCartIds = [];
        },
    },
    mounted() {
        let self = this;
        this.bindCategories();

        document.addEventListener('click', function (e) {
            if (e.target && e.target.closest('.replacement-anchor')) {
                e.preventDefault(); // a 태그 기본 이동 방지
                const anchor = e.target.closest('.replacement-anchor');
                const targetBtn = anchor.closest('.product').querySelector('.replacement-btn');
                if (targetBtn) targetBtn.click();
            }

            if (e.target && e.target.closest('.replacement-btn')) {
                const targetBtn = e.target.closest('.replacement-btn');
                document.querySelectorAll('.replacement-btn').forEach(btn => {
                    btn.querySelector('label').classList.remove('active');
                });

                targetBtn.querySelector('label').classList.add('active');

                self.replacementProductId = targetBtn.dataset.idx;
            }
        });
    }
};
</script>

<style scoped>
.address-form-list p {
    cursor: pointer;
}

.search-icon {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='48px' height='48px'%3E%3Cpath fill-rule='evenodd' fill-opacity='0' fill='rgb(248, 248, 248)' d='M-0.000,48.000 L-0.000,-0.000 L48.000,-0.000 L48.000,48.000 L-0.000,48.000 Z'/%3E%3Cpath fill-rule='evenodd' fill='rgb(34, 34, 34)' d='M31.000,28.000 L29.420,28.000 L28.860,27.460 C30.820,25.180 32.000,22.220 32.000,19.000 C32.000,11.820 26.180,6.000 19.000,6.000 C11.820,6.000 6.000,11.820 6.000,19.000 C6.000,26.180 11.820,32.000 19.000,32.000 C22.220,32.000 25.180,30.820 27.460,28.860 L28.000,29.420 L28.000,31.000 L38.000,40.980 L40.980,38.000 L31.000,28.000 ZM19.000,28.000 C14.020,28.000 10.000,23.980 10.000,19.000 C10.000,14.020 14.020,10.000 19.000,10.000 C23.980,10.000 28.000,14.020 28.000,19.000 C28.000,23.980 23.980,28.000 19.000,28.000 Z'/%3E%3C/svg%3E");
    width: 24px;
    height: 24px;
    background-size: 24px;
    display: inline-block;
    border: none;
    background-color: transparent;
    position: absolute;
    right: 20px;
    top: 10px;
    background-repeat: no-repeat;
}

.input-bottom {
    border-right: none;
    border-top: none;
    border-radius: 0;
    border-left: none;
    border-bottom: 1px solid #222;
}

.address-form {
    margin-top: 1.0rem;
    height: 50vh;
    overflow-y: auto;
    overflow-x: hidden;
    font-size: 14px;
}

.searchClear-wrap {
    position: absolute;
    z-index: 1;
    right: 65px;
    top: 3px;
    width: 18px;
    height: 18px;
    display: inline-block;
    border: none;
    background-color: transparent;
}

.searchClear {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='36px' height='36px'%3E%3Cpath fill-rule='evenodd' fill-opacity='0' fill='rgb(248, 248, 248)' d='M-0.000,36.000 L-0.000,-0.000 L36.000,-0.000 L36.000,36.000 L-0.000,36.000 Z'/%3E%3Cpath fill-rule='evenodd' fill='rgb(191, 191, 191)' d='M18.000,3.000 C9.705,3.000 3.000,9.705 3.000,18.000 C3.000,26.295 9.705,33.000 18.000,33.000 C26.295,33.000 33.000,26.295 33.000,18.000 C33.000,9.705 26.295,3.000 18.000,3.000 ZM25.500,23.385 L23.385,25.500 L18.000,20.115 L12.615,25.500 L10.500,23.385 L15.885,18.000 L10.500,12.615 L12.615,10.500 L18.000,15.885 L23.385,10.500 L25.500,12.615 L20.115,18.000 L25.500,23.385 Z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    width: 18px;
    position: absolute;
    height: 18px;
    background-size: 18px;

}

.address-form-list ul li:first-child {
    border-top: none;
    padding-top: 0;
}

.address-form-list ul li {
    border-top: 1px solid #e6e6e6;
    padding-top: 20px;
}

.modal-dialog {
    margin: 0.5rem;
}

@media (min-width: 576px) {
    .modal-dialog {
        margin: 1.75rem auto;
        max-width: 500px;
    }
}

.modal-body {
    padding: 1rem;
    height: auto;
}

.bt-btn {
    text-align: center;
    position: absolute;
    bottom: 20px;
    width: 90%;
    line-height: 50px;
    background: #222;
    border-radius: 4px;
    border: none;
}

.bt-btn span {
    color:#fff;
}

.bt-btn.disabled {
    border: 0;
    color: #767676;
    background-color: #EDEDED;
}

.bt-btn.disabled:hover {
    color: #767676;
    background-color: #EDEDED;
}

.bt-btn.disabled span {
    color: #767676;
}

.dim-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 998;
}
</style>
